import * as React from 'react'

import { SimpleTitleButtonHero } from 'sdk/sections'
import { HeroTitle } from 'components/hero-title/HeroTitle'
import lightningIcon from 'shared/assets/icons/lightning-gradient.svg'

import { HomeHeroCmsContent } from 'core/services/cms/interfaces'

interface HeroProps {
  content: HomeHeroCmsContent
}

export const Hero: React.FC<HeroProps> = ({ content }) => {
  const title = (
    <HeroTitle
      pillText={content.pillText}
      pillIcon={lightningIcon}
      titleText={content.titleText}
    />
  )

  return (
    <SimpleTitleButtonHero
      title={title}
      description={content.description}
      imageLink={content.backgroundImageUrl}
      videoLink={content.backgroundVideoUrl}
      alignment="center"
    />
  )
}
